/* DOMINIONZ – theme.js (sans dépendances) */
(function () {
  'use strict';

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var theme = window.theme || { routes: {} };
  var body = document.body;
  var STR = theme.strings || {};
  // Traduction : tr('perPair', { price: '59 DH' }) → « 59 DH la paire » / « 59 DH للزوج »
  function tr(key, vars) {
    var str = STR[key] || '';
    Object.keys(vars || {}).forEach(function (k) { str = str.split('{{ ' + k + ' }}').join(vars[k]); });
    return str;
  }

  /* ---------- Formatage des prix ---------- */
  function formatMoney(cents) {
    var format = theme.moneyFormat || '{{amount}} DH';
    var value = (cents / 100);
    function fmt(n, dec, thou, sep) {
      var parts = n.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts.join(sep);
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return fmt(value, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(value, 0, '.', ',');
        case 'amount_with_space_separator': return fmt(value, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return fmt(value, 0, ' ', ',');
        default: return fmt(value, 2, ',', '.');
      }
    });
  }

  /* ---------- Barre d'annonce ---------- */
  var announceItems = $$('.announce__item');
  if (announceItems.length > 1) {
    var ai = 0;
    var showAnnounce = function (n) {
      announceItems[ai].classList.remove('is-active');
      ai = (n + announceItems.length) % announceItems.length;
      announceItems[ai].classList.add('is-active');
    };
    var announceTimer = setInterval(function () { showAnnounce(ai + 1); }, 4000);
    $$('[data-announce-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        clearInterval(announceTimer);
        var dir = parseInt(b.getAttribute('data-announce-step'), 10);
        if (document.documentElement.dir === 'rtl') dir = -dir;
        showAnnounce(ai + dir);
      });
    });
  }

  /* ---------- Panneaux (menu mobile, panier, modales) ---------- */
  var lastFocus = null;
  function openPanel(el) {
    if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    body.style.overflow = 'hidden';
    var focusable = el.querySelector('[role="dialog"]') || el;
    setTimeout(function () { focusable.focus && focusable.focus(); }, 50);
  }
  function closePanel(el) {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') $$('.is-open[aria-hidden="false"]').forEach(closePanel);
  });

  // Menu mobile
  var mobileNav = $('[data-mobile-nav]');
  var burger = $('[data-mobile-open]');
  if (burger) burger.addEventListener('click', function () { openPanel(mobileNav); burger.setAttribute('aria-expanded', 'true'); });
  $$('[data-mobile-close]').forEach(function (b) { b.addEventListener('click', function () { closePanel(mobileNav); if (burger) burger.setAttribute('aria-expanded', 'false'); }); });

  // Méga-menu : accessibilité clavier / tactile
  $$('.nav__item--mega').forEach(function (item) {
    var link = item.querySelector('.nav__link');
    item.addEventListener('mouseenter', function () { link.setAttribute('aria-expanded', 'true'); });
    item.addEventListener('mouseleave', function () { link.setAttribute('aria-expanded', 'false'); item.classList.remove('is-open'); });
    link.addEventListener('touchend', function (e) {
      if (!item.classList.contains('is-open')) { e.preventDefault(); $$('.nav__item--mega.is-open').forEach(function (o) { o.classList.remove('is-open'); }); item.classList.add('is-open'); }
    });
  });

  // Recherche
  var searchBar = $('[data-search-bar]');
  $$('[data-search-open]').forEach(function (b) {
    b.addEventListener('click', function () {
      searchBar.hidden = !searchBar.hidden;
      if (!searchBar.hidden) $('input[type=search]', searchBar).focus();
    });
  });
  $$('[data-search-close]').forEach(function (b) { b.addEventListener('click', function () { searchBar.hidden = true; }); });

  // Modales
  $$('[data-modal-open]').forEach(function (b) {
    b.addEventListener('click', function () { openPanel(document.getElementById(b.getAttribute('data-modal-open'))); });
  });
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-modal-close]')) closePanel(e.target.closest('[data-modal]'));
  });

  /* ---------- Sliders ---------- */
  function initSliders(scope) {
    $$('.slider', scope).forEach(function (slider) {
      var track = $('[data-slider-track]', slider);
      var prev = $('[data-slider-prev]', slider);
      var next = $('[data-slider-next]', slider);
      if (!track || !prev || !next) return;
      function step() { var s = track.querySelector('.slider__slide'); return s ? s.getBoundingClientRect().width + 20 : 300; }
      function update() {
        prev.disabled = track.scrollLeft < 8;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 8;
      }
      prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }
  initSliders(document);

  /* ---------- Panier latéral (AJAX) ---------- */
  var drawerSectionId = 'cart-drawer';
  function getDrawer() { return $('[data-cart-drawer]'); }

  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
    });
  }

  function renderDrawer(html, open) {
    var wrapper = document.getElementById('shopify-section-' + drawerSectionId);
    if (html && wrapper) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-cart-drawer]');
      var old = getDrawer();
      if (fresh && old) {
        var wasOpen = old.classList.contains('is-open');
        old.innerHTML = fresh.innerHTML;
        if (wasOpen) old.classList.add('is-open');
      }
    }
    if (open) openPanel(getDrawer());
  }

  function refreshCart(open) {
    return fetch(theme.routes.root + '?sections=' + drawerSectionId, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (sections) { renderDrawer(sections[drawerSectionId], open); return fetch(theme.routes.cart + '.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCount(cart.item_count); return cart; });
  }

  function addToCart(formData) {
    formData.append('sections', drawerSectionId);
    formData.append('sections_url', window.location.pathname);
    return fetch(theme.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: formData
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok || data.status) throw new Error(data.description || data.message || tr('error'));
        return data;
      });
    });
  }

  // Ouvrir le panier depuis l'icône
  $$('[data-cart-open]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      if (!getDrawer() || body.classList.contains('template-cart')) return;
      e.preventDefault();
      openPanel(getDrawer());
    });
  });

  document.addEventListener('click', function (e) {
    var closeBtn = e.target.closest('[data-cart-close]');
    if (closeBtn) { closePanel(getDrawer()); return; }

    var change = e.target.closest('[data-line-change]');
    if (change) {
      var drawer = getDrawer();
      drawer.classList.add('is-loading');
      fetch(theme.routes.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: parseInt(change.getAttribute('data-line-change'), 10), quantity: parseInt(change.getAttribute('data-qty'), 10), sections: drawerSectionId })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          updateCount(cart.item_count);
          if (cart.sections) renderDrawer(cart.sections[drawerSectionId], false);
          else return refreshCart(false);
        })
        .finally(function () { getDrawer().classList.remove('is-loading'); });
    }
  });

  /* Construit les données d'ajout : paire seule, ou pack si un palier 3/5 est choisi */
  function buildFormData(form) {
    var section = form.closest('[data-product]');
    var tier = section && section.querySelector('[data-qb] input[name="tier"]:checked');
    var n = tier ? parseInt(tier.getAttribute('data-pack-size'), 10) : 1;
    var packVariant = tier ? tier.getAttribute('data-pack-variant') : '0';
    if (!tier || n <= 1) return new FormData(form);
    if (!packVariant || packVariant === '0') throw new Error(tr('packNotSet'));
    var qb = section.querySelector('[data-qb]');
    var title = qb.getAttribute('data-title');
    var handle = qb.getAttribute('data-handle');
    var sizeEl = section.querySelector('[data-option-label="0"]');
    var size = sizeEl ? sizeEl.textContent.trim() : '';
    var fd = new FormData();
    fd.append('id', packVariant);
    fd.append('quantity', '1');
    var items = [];
    for (var i = 1; i <= n; i++) {
      fd.append('properties[Paire ' + i + ']', title + (size ? ' – ' + size : ''));
      items.push(handle + ':' + size);
    }
    fd.append('properties[_items]', items.join(','));
    return fd;
  }

  // Formulaires d'ajout (fiche produit + ajout rapide)
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form || !getDrawer()) return;
    e.preventDefault();
    var btn = form.querySelector('[type=submit]');
    var err = form.querySelector('[data-form-error]');
    if (btn) btn.setAttribute('aria-busy', 'true');
    if (err) err.hidden = true;
    Promise.resolve().then(function () { return addToCart(buildFormData(form)); })
      .then(function (data) {
        if (data.sections) renderDrawer(data.sections[drawerSectionId], true);
        return fetch(theme.routes.cart + '.js').then(function (r) { return r.json(); }).then(function (c) { updateCount(c.item_count); if (!data.sections) refreshCart(true); });
      })
      .catch(function (error) { if (err) { err.textContent = error.message; err.hidden = false; } else { alert(error.message); } })
      .finally(function () { if (btn) btn.removeAttribute('aria-busy'); });
  });

  /* ---------- Fiche produit ---------- */
  var product = $('[data-product]');
  if (product) {
    var variantsEl = $('[data-variants-json]', product);
    var variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
    var idInput = $('[data-variant-id]', product);
    var addBtn = $('[data-add-button]', product);
    var addLabel = $('[data-add-label]', product);
    var codBtn = $('[data-buy-now]', product);
    var stickyAdd = $('[data-sticky-add]', product);
    var waLink = $('[data-wa-link]', product);

    function selectedOptions() {
      var groups = $$('.variants__group', product);
      return groups.map(function (g, i) {
        var checked = g.querySelector('input[data-option-index="' + i + '"]:checked');
        return checked ? checked.value : null;
      });
    }

    function markAvailability(opts) {
      // Barrer les valeurs indisponibles pour la combinaison courante
      $$('.variants__group', product).forEach(function (g, idx) {
        $$('.pill', g).forEach(function (pill) {
          var input = pill.querySelector('input');
          var test = opts.slice(); test[idx] = input.value;
          var ok = variants.some(function (v) { return v.available && v.options.every(function (o, j) { return o === test[j]; }); });
          pill.classList.toggle('is-unavailable', !ok);
        });
      });
    }

    function onVariantChange() {
      var opts = selectedOptions();
      var variant = variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
      opts.forEach(function (val, i) { var l = $('[data-option-label="' + i + '"]', product); if (l) l.textContent = val; });
      markAvailability(opts);
      if (!variant) {
        if (addBtn) addBtn.disabled = true;
        if (codBtn) codBtn.disabled = true;
        if (addLabel) addLabel.textContent = tr('unavailable');
        return;
      }
      idInput.value = variant.id;
      var available = variant.available;
      if (addBtn) addBtn.disabled = !available;
      if (codBtn) codBtn.disabled = !available;
      if (stickyAdd) stickyAdd.disabled = !available;
      if (addLabel) addLabel.textContent = available ? tr('addToCart') : tr('soldOut');

      // Prix
      var priceEl = $('.product__price [data-price]', product);
      if (priceEl) {
        var html = '<span class="price__current">' + formatMoney(variant.price) + '</span>';
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          html += '<s class="price__compare">' + formatMoney(variant.compare_at_price) + '</s>';
          html += '<span class="price__save">-' + Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) + '%</span>';
          priceEl.classList.add('price--sale');
        } else { priceEl.classList.remove('price--sale'); }
        priceEl.innerHTML = html;
      }
      var sp = $('[data-sticky-price]', product);
      if (sp) sp.textContent = formatMoney(variant.price);

      // Image de la variante
      if (variant.featured_media) showMedia(String(variant.featured_media.id));

      // Lien WhatsApp
      if (waLink) {
        var msg = tr('waOrder', { item: waLink.getAttribute('data-product-title') + ' (' + variant.title + ')', link: waLink.getAttribute('data-product-link') });
        waLink.href = waLink.getAttribute('data-wa-base') + '?text=' + encodeURIComponent(msg);
      }

      if (window.DZ && window.DZ.onVariant) window.DZ.onVariant(variant);

      // URL
      if (window.history && history.replaceState) {
        history.replaceState({}, '', product.getAttribute('data-product-url') + '?variant=' + variant.id);
      }
    }
    $$('[data-option-index]', product).forEach(function (input) { input.addEventListener('change', onVariantChange); });
    if (variants.length) markAvailability(selectedOptions());

    // Galerie
    function showMedia(id) {
      var slides = $$('.gallery__slide', product);
      var match = slides.some(function (s) { return s.getAttribute('data-media-id') === id; });
      if (!match) return;
      slides.forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-media-id') === id); });
      $$('.gallery__thumb', product).forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-thumb') === id); });
    }
    $$('.gallery__thumb', product).forEach(function (t) { t.addEventListener('click', function () { showMedia(t.getAttribute('data-thumb')); }); });

    // Balayage de la galerie sur mobile
    var main = $('.gallery__main', product);
    if (main) {
      var x0 = null;
      main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) < 40) return;
        var slides = $$('.gallery__slide', product);
        var i = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
        var n = (i + (dx < 0 ? 1 : -1) + slides.length) % slides.length;
        showMedia(slides[n].getAttribute('data-media-id'));
      });
    }

    // Quantité
    var qty = $('[data-qty-input]', product);
    var minus = $('[data-qty-minus]', product);
    var plus = $('[data-qty-plus]', product);
    if (qty && minus && plus) {
      minus.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); });
      plus.addEventListener('click', function () { qty.value = (parseInt(qty.value, 10) || 1) + 1; });
    }

    // Commander directement (paiement à la livraison) : ajout + passage à la caisse
    if (codBtn) {
      codBtn.addEventListener('click', function () {
        var form = codBtn.closest('form');
        codBtn.setAttribute('aria-busy', 'true');
        Promise.resolve().then(function () { return fetch(theme.routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: buildFormData(form) }); })
          .then(function (r) { return r.json().then(function (d) { if (!r.ok || d.status) throw new Error(d.description || tr('error')); }); })
          .then(function () { window.location.href = '/checkout'; })
          .catch(function (error) {
            var err = form.querySelector('[data-form-error]');
            if (err) { err.textContent = error.message; err.hidden = false; }
            codBtn.removeAttribute('aria-busy');
          });
      });
    }

    // Barre d'achat mobile
    var sticky = $('[data-sticky-buy]', product);
    var buyZone = $('.buy', product);
    if (sticky && buyZone && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        sticky.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
      }).observe(buyZone);
      if (stickyAdd) stickyAdd.addEventListener('click', function () {
        if (codBtn && !codBtn.disabled) codBtn.click();
        else buyZone.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
  }

  /* ---------- Produits recommandés ---------- */
  $$('[data-recommendations]').forEach(function (el) {
    fetch(el.getAttribute('data-url'))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim().length) { el.innerHTML = fresh.innerHTML; initSliders(el); }
      });
  });

  /* ---------- Filtres & tri ---------- */
  $$('[data-auto-submit]').forEach(function (el) {
    el.addEventListener('change', function () { el.form && el.form.submit(); });
  });
  $$('.filter').forEach(function (d) {
    d.addEventListener('toggle', function () {
      if (d.open) $$('.filter').forEach(function (o) { if (o !== d) o.open = false; });
    });
  });

  /* ==========================================================================
     OFFRE, PACKS & UPSELLS
     ========================================================================== */
  window.DZ = window.DZ || {};

  function postJSON(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok || d.status) throw new Error(d.description || d.message || tr('error')); return d; }); });
  }
  function afterCartChange(data) {
    if (data && data.sections && data.sections[drawerSectionId]) {
      renderDrawer(data.sections[drawerSectionId], true);
      return fetch(theme.routes.cart + '.js').then(function (r) { return r.json(); }).then(function (c) { updateCount(c.item_count); });
    }
    return refreshCart(true);
  }

  /* ---------- Sélecteur d'offre (fiche produit) ---------- */
  var qb = $('[data-qb]');
  if (qb) {
    var qbSection = qb.closest('[data-product]');
    var qbBuy = $('.buy', qbSection);
    var qbAddLabel = $('[data-add-label]', qbSection);
    var qbSticky = $('[data-sticky-price]', qbSection);
    var qbMix = $('[data-qb-mix]', qb);
    var qbWa = $('[data-wa-link]', qbSection);
    var currentVariantPrice = null;

    function currentSize() { var el = $('[data-option-label="0"]', qbSection); return el ? el.textContent.trim() : ''; }
    function updateQb() {
      var r = $('input[name="tier"]:checked', qb);
      if (!r) return;
      var n = parseInt(r.getAttribute('data-pack-size'), 10);
      var price = parseInt(r.getAttribute('data-pack-price'), 10);
      if (n === 1 && currentVariantPrice !== null) price = currentVariantPrice;
      if (qbBuy) qbBuy.classList.toggle('is-pack', n > 1);
      var addBtn = $('[data-add-button]', qbSection);
      if (qbAddLabel && addBtn && !addBtn.disabled) qbAddLabel.textContent = n > 1 ? tr('addPackPrice', { n: n, price: formatMoney(price) }) : tr('addToCartPrice', { price: formatMoney(price) });
      if (qbSticky) qbSticky.textContent = (n > 1 ? tr('packN', { n: n }) + ' · ' : '') + formatMoney(price);
      if (qbMix && qb.getAttribute('data-builder-url')) {
        var size = currentSize();
        qbMix.href = qb.getAttribute('data-builder-url') + '?pack=' + Math.max(n, 3) + '&items=' + encodeURIComponent(qb.getAttribute('data-handle') + ':' + size + ',');
      }
      if (qbWa) {
        var label = (n > 1 ? tr('packPairs', { n: n }) + ' – ' : '') + qbWa.getAttribute('data-product-title') + (currentSize() ? ' (' + currentSize() + ')' : '');
        qbWa.href = qbWa.getAttribute('data-wa-base') + '?text=' + encodeURIComponent(tr('waOrder', { item: label, link: qbWa.getAttribute('data-product-link') }));
      }
    }
    // Pré-sélectionner le pack le plus populaire (3) si disponible
    var popular = $$('input[name="tier"]', qb).filter(function (i) { return i.getAttribute('data-pack-size') === '3' && !i.disabled; })[0];
    if (popular) popular.checked = true;
    $$('input[name="tier"]', qb).forEach(function (i) { i.addEventListener('change', updateQb); });
    window.DZ.onVariantQb = function (variant) {
      currentVariantPrice = variant.price;
      var single = $('input[name="tier"][data-pack-size="1"]', qb);
      if (single) {
        single.setAttribute('data-pack-price', variant.price);
        var lab = single.closest('.tier');
        var per = $('.tier__per', lab), pr = $('.tier__price strong', lab);
        if (per) per.textContent = tr('perPair', { price: formatMoney(variant.price) });
        if (pr) pr.textContent = formatMoney(variant.price);
      }
      updateQb();
    };
    updateQb();
  }

  /* ---------- Stock faible (fiche produit) ---------- */
  var invEl = $('[data-inventory]');
  var inventory = {};
  try { inventory = invEl ? JSON.parse(invEl.textContent) : {}; } catch (e) { inventory = {}; }
  window.DZ.onVariant = function (variant) {
    var low = $('[data-low-stock]');
    var threshold = low ? parseInt(low.getAttribute('data-threshold'), 10) || 0 : 0;
    if (low) {
      var q = inventory[String(variant.id)];
      var show = threshold > 0 && typeof q === 'number' && q > 0 && q <= threshold;
      low.hidden = !show;
      if (show) $('[data-low-stock-qty]', low).textContent = q;
    }
    if (window.DZ.onVariantQb) window.DZ.onVariantQb(variant);
  };

  /* ---------- Ajout express (upsells panier) ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-quick-add]');
    if (!b) return;
    b.setAttribute('aria-busy', 'true');
    postJSON(theme.routes.cartAdd + '.js', { items: [{ id: parseInt(b.getAttribute('data-quick-add'), 10), quantity: 1 }], sections: drawerSectionId })
      .then(function (d) { var dd = b.closest('details.qa'); if (dd) dd.open = false; return afterCartChange(d); })
      .catch(function (err) { b.textContent = err.message; })
      .finally(function () { b.removeAttribute('aria-busy'); });
  });

  /* ---------- « Commandez avant XXh, expédié aujourd'hui » ---------- */
  function moroccoNow() {
    try {
      var parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Africa/Casablanca', hour: 'numeric', minute: 'numeric', weekday: 'short', hour12: false }).formatToParts(new Date());
      var o = {}; parts.forEach(function (p) { o[p.type] = p.value; });
      return { h: parseInt(o.hour, 10) % 24, m: parseInt(o.minute, 10), d: o.weekday };
    } catch (e) { var d = new Date(); return { h: d.getHours(), m: d.getMinutes(), d: ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'][d.getDay()] }; }
  }
  function renderCutoffs() {
    $$('[data-cutoff]').forEach(function (el) {
      var cutoff = parseInt(el.getAttribute('data-hour'), 10);
      var sat = el.getAttribute('data-sat') === 'true';
      var now = moroccoNow();
      var shipsToday = now.d !== 'Sun' && (now.d !== 'Sat' || sat);
      var text;
      if (shipsToday && now.h < cutoff) {
        var mins = (cutoff - now.h) * 60 - now.m;
        var hh = Math.floor(mins / 60), mm = mins % 60;
        text = tr('cutoffToday', { time: hh ? tr('hoursMinutes', { h: hh, m: mm }) : tr('minutes', { m: mm }) });
      } else {
        var next = (now.d === 'Sat' && !sat) || now.d === 'Sun' || (now.d === 'Sat' && sat && now.h >= cutoff) ? tr('monday') : tr('tomorrow');
        if (now.d === 'Fri' && now.h >= cutoff && !sat) next = tr('monday');
        text = tr('cutoffLater', { day: next });
      }
      $('[data-cutoff-text]', el).innerHTML = text;
      el.hidden = false;
    });
  }
  renderCutoffs();
  setInterval(renderCutoffs, 60000);
  // Le panier est re-rendu en AJAX : relancer l'affichage après chaque mise à jour
  new MutationObserver(function () { $$('[data-cutoff][hidden]').length && renderCutoffs(); }).observe(document.body, { childList: true, subtree: true });

  /* ---------- Compose ton pack ---------- */
  var builder = $('[data-pack-builder]');
  if (builder) {
    var single = parseInt(builder.getAttribute('data-single'), 10) || 0;
    var threshold = parseInt(builder.getAttribute('data-threshold'), 10) || 0;
    var sizeInputs = $$('input[name="pack-size"]', builder);
    var picks = $$('[data-pick]', builder);
    var slotsEl = $('[data-tray-slots]', builder);
    var addBtnB = $('[data-tray-add]', builder);
    var errEl = $('[data-tray-error]', builder);
    var params = new URLSearchParams(window.location.search);
    var chosen = [];           // { handle, title, image, size }
    var replaceKeys = (params.get('replace') || '').split(',').filter(Boolean);

    function tierInput() { return $('input[name="pack-size"]:checked', builder) || sizeInputs[sizeInputs.length - 1]; }
    function tierSize() { return parseInt(tierInput().value, 10); }
    function nextTier(n) { return sizeInputs.map(function (i) { return i; }).filter(function (i) { return parseInt(i.value, 10) > n; })[0]; }
    function findPick(handle) { return picks.filter(function (p) { return p.getAttribute('data-handle') === handle; })[0]; }
    function pickData(pick, size) {
      return { handle: pick.getAttribute('data-handle'), title: pick.getAttribute('data-title'), image: pick.getAttribute('data-image'), size: size || '' };
    }
    function pickSize(pick) { var r = $('.pick__sizes input:checked', pick); return r ? r.value : ''; }

    // Pré-remplissage depuis l'URL (?pack=5&items=handle:taille,...)
    var wanted = parseInt(params.get('pack'), 10);
    if (wanted) sizeInputs.forEach(function (i) { i.checked = parseInt(i.value, 10) === wanted; });
    if (!tierInput().checked) tierInput().checked = true;
    (params.get('items') || '').split(',').filter(Boolean).forEach(function (pair) {
      var bits = pair.split(':'); var pick = findPick(bits[0]);
      if (pick && chosen.length < tierSize()) chosen.push(pickData(pick, bits.slice(1).join(':')));
    });

    function render() {
      var n = tierSize();
      var price = parseInt(tierInput().getAttribute('data-price'), 10);
      if (chosen.length > n) chosen = chosen.slice(0, n);
      var html = '';
      for (var i = 0; i < n; i++) {
        var c = chosen[i];
        html += c
          ? '<div class="slot is-filled">' + (c.image ? '<img src="' + c.image + '" alt="">' : '') + (c.size ? '<span class="slot__size">' + c.size + '</span>' : '') + '<button type="button" class="slot__remove" data-slot-remove="' + i + '" aria-label="' + tr('removeTitle', { title: c.title }) + '">✕</button></div>'
          : '<div class="slot" aria-hidden="true">' + (i + 1) + '</div>';
      }
      slotsEl.innerHTML = html;
      $('[data-tray-count]', builder).textContent = chosen.length + '/' + n;
      $('[data-tray-fill]', builder).style.width = (chosen.length * 100 / n) + '%';
      var full = single * n;
      $('[data-tray-price]', builder).textContent = formatMoney(price);
      $('[data-tray-full]', builder).textContent = full > price ? formatMoney(full) : '';
      var save = full - price;
      var freeShip = threshold > 0 && price >= threshold;
      $('[data-tray-save]', builder).textContent = save > 0 ? tr('youSave', { amount: formatMoney(save) }) + (freeShip ? tr('plusFreeShipping') : '') : '';
      var missing = n - chosen.length;
      var hint = $('[data-tray-hint]', builder);
      hint.classList.toggle('is-done', missing === 0);
      hint.textContent = missing === 0 ? tr('packComplete') : tr('leftToChoose', { n: missing });
      // Upsell : passer au pack supérieur
      var up = $('[data-tray-up]', builder);
      var nt = nextTier(n);
      if (!up) { up = document.createElement('div'); up.className = 'tray__up'; up.setAttribute('data-tray-up', ''); hint.insertAdjacentElement('afterend', up); }
      if (missing === 0 && nt) {
        var diff = parseInt(nt.getAttribute('data-price'), 10) - price;
        var extra = parseInt(nt.value, 10) - n;
        up.innerHTML = '<span>' + tr('upgrade', { extra: extra, diff: formatMoney(diff), per: formatMoney(Math.round(diff / extra)), single: formatMoney(single) }) + '</span><button type="button" class="btn btn--small btn--accent" data-upgrade="' + nt.value + '">' + tr('upgradeBtn', { n: nt.value }) + '</button>';
        up.hidden = false;
      } else { up.hidden = true; }
      addBtnB.disabled = missing !== 0;
      addBtnB.textContent = missing === 0 ? tr('addMyPack', { n: n, price: formatMoney(price) }) : tr('chooseMore', { n: missing });
      picks.forEach(function (p) {
        var count = chosen.filter(function (c) { return c.handle === p.getAttribute('data-handle'); }).length;
        var badge = $('[data-pick-count]', p);
        badge.textContent = '×' + count; badge.hidden = !count;
        p.classList.toggle('is-picked', count > 0);
      });
    }

    function addPick(pick) {
      var n = tierSize();
      if (chosen.length >= n) {
        var nt = nextTier(n);
        if (!nt) { $('[data-tray-hint]', builder).textContent = tr('packFull'); return; }
        nt.checked = true; // montée en gamme automatique
      }
      chosen.push(pickData(pick, pickSize(pick)));
      render();
    }

    builder.addEventListener('click', function (e) {
      var add = e.target.closest('[data-pick-add]');
      if (add) { addPick(add.closest('[data-pick]')); return; }
      var rm = e.target.closest('[data-slot-remove]');
      if (rm) { chosen.splice(parseInt(rm.getAttribute('data-slot-remove'), 10), 1); render(); return; }
      var upg = e.target.closest('[data-upgrade]');
      if (upg) { sizeInputs.forEach(function (i) { i.checked = i.value === upg.getAttribute('data-upgrade'); }); render(); return; }
      if (e.target.closest('[data-tray-random]')) {
        var pool = picks.filter(function (p) { return !$('[data-pick-add]', p).disabled; });
        while (pool.length && chosen.length < tierSize()) { var p = pool[Math.floor(Math.random() * pool.length)]; chosen.push(pickData(p, pickSize(p))); }
        render();
      }
    });
    sizeInputs.forEach(function (i) { i.addEventListener('change', render); });

    addBtnB.addEventListener('click', function () {
      var input = tierInput();
      var variant = input.getAttribute('data-variant');
      errEl.hidden = true;
      if (!variant || variant === '0') { errEl.textContent = tr('packNotSet'); errEl.hidden = false; return; }
      var props = {};
      chosen.forEach(function (c, i) { props['Paire ' + (i + 1)] = c.title + (c.size ? ' – ' + c.size : ''); });
      props._items = chosen.map(function (c) { return c.handle + ':' + c.size; }).join(',');
      addBtnB.setAttribute('aria-busy', 'true');
      var clear = replaceKeys.length
        ? postJSON(theme.routes.root + 'cart/update.js', { updates: replaceKeys.reduce(function (o, k) { o[k] = 0; return o; }, {}) }).catch(function () {})
        : Promise.resolve();
      clear
        .then(function () { return postJSON(theme.routes.cartAdd + '.js', { items: [{ id: parseInt(variant, 10), quantity: 1, properties: props }], sections: drawerSectionId }); })
        .then(function (data) { replaceKeys = []; return afterCartChange(data); })
        .catch(function (err) { errEl.textContent = err.message; errEl.hidden = false; })
        .finally(function () { addBtnB.removeAttribute('aria-busy'); });
    });

    render();
  }

  /* ---------- Pop-up e-mail ---------- */
  var popup = $('[data-email-popup]');
  if (popup) {
    var KEY = 'dz_email_popup';
    var store = {
      get: function () { try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) { return {}; } },
      set: function (v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} }
    };
    var state = store.get();
    var days = parseInt(popup.getAttribute('data-days'), 10) || 7;
    var success = $('[data-popup-success]', popup);
    var hasError = $('[data-popup-error]', popup);
    var shown = false;

    function openPopup() {
      if (shown) return;
      if ($('[data-cart-drawer].is-open') || $('[data-mobile-nav].is-open')) return;
      shown = true;
      openPanel(popup);
    }
    function closePopup() {
      closePanel(popup);
      if (!success) { state.dismissed = Date.now(); store.set(state); }
    }

    if (success || hasError) {
      // Retour après inscription (ou erreur) : on ré-ouvre pour afficher le code / le message
      if (success) { state.subscribed = true; store.set(state); }
      shown = false; openPopup();
    } else {
      var recentlyDismissed = state.dismissed && (Date.now() - state.dismissed) < days * 864e5;
      if (!state.subscribed && !recentlyDismissed && !/[?&]customer_posted=/.test(location.search)) {
        var delay = (parseInt(popup.getAttribute('data-delay'), 10) || 12) * 1000;
        setTimeout(openPopup, delay);
        if (popup.getAttribute('data-exit') === 'true' && window.matchMedia('(pointer: fine)').matches) {
          document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY <= 0) openPopup(); });
        }
      }
    }
    popup.addEventListener('click', function (e) {
      if (e.target.closest('[data-popup-close]')) closePopup();
      var copy = e.target.closest('[data-popup-copy]');
      if (copy) {
        var code = $('[data-popup-code]', popup).textContent.trim();
        var done = function () { copy.textContent = tr('copied'); };
        if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, function () {});
        else { var r = document.createRange(); r.selectNodeContents($('[data-popup-code]', popup)); var sel = window.getSelection(); sel.removeAllRanges(); sel.addRange(r); }
      }
    });
    popup.addEventListener('submit', function () { state.subscribed = true; store.set(state); });
  }
})();
